import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Portal from 'portal/Portal';
import BaseForm from 'containers/Base/BaseForm';
import { generalSection, initialValues, validationSchema } from './options';
import {
  getSecurityCompanyDetail,
  updateSecurityCompany,
} from 'reducers/securityCompany';
import { isBase64 } from 'utils/checkImage';
import { HelpLinks } from 'utils/constants/helpLinks';
import { getCountryList } from 'reducers/utils';
import { PANEL } from 'utils/constants';
import { makeStyles } from '@material-ui/core/styles';
import { Paper } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  formPaper: {
    position: 'absolute',
    zIndex: 100,
    top: '50%',
    right: '50%',
    transform: 'translate(60%,-40%)',
    background: 'none',
    [theme.breakpoints.down('md')]: {
      right: '60%',
      top: '50%',
      width: '30%',
    },
    [theme.breakpoints.down('sm')]: {
      right: '80%',
      top: '50%',
      width: '40%',
    },
  },
}));
const CompanyProfileForm = ({
  companyProfile,
  close,
  updateSecurityCompany,
  countries,
}) => {
  const classes = useStyles();
  const onSave = async values => {
    const { id, ...details } = companyProfile;
    Reflect.deleteProperty(details, 'subscriptions');
    const {
      image,
      address,
      bookingPhoneCountry,
      bookingPhone,
      operationPhone,
      operationPhoneCountry,
    } = values;

    const requestBody = {
      ...details,
      bookingPhone: { country: bookingPhoneCountry, number: bookingPhone },
      operationPhone: {
        country: operationPhoneCountry,
        number: operationPhone,
      },
      address,
      ...(image && isBase64(image) && { imageBase64: image }),
    };

    updateSecurityCompany(id, requestBody, PANEL.COMPANY_PROFILE);
  };

  return (
    <Portal id="portal">
      <Paper className={classes.formPaper}>
        <BaseForm
          formTitle="edit_company_profile"
          edit={true}
          initialValues={initialValues(companyProfile)}
          closeForm={close}
          saveHoverText="action_save_changes"
          generalSection={generalSection({ countries })}
          imageRequired={true}
          validationSchema={validationSchema}
          enableReinitialize={true}
          onSubmit={onSave}
          allowToArchive={false}
          size="sm"
          formInfo={{
            link: HelpLinks.companyLink,
            value: HelpLinks.companyText,
          }}
        />
      </Paper>
    </Portal>
  );
};

const mapStateToProps = state => ({
  companyProfile: getSecurityCompanyDetail(state),
  countries: getCountryList(state),
});
const mapDispatchToProps = dispatch => ({
  updateSecurityCompany: (id, securityCompany, refreshDetail) =>
    dispatch(updateSecurityCompany(id, securityCompany, refreshDetail)),
});

CompanyProfileForm.propTypes = {
  companyProfile: PropTypes.object,
  close: PropTypes.func.isRequired,
  updateSecurityCompany: PropTypes.func.isRequired,
  countries: PropTypes.array,
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyProfileForm);
